var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTablierIcone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 19.53 20.04",
    width: "1em",
    height: "1em",
    className: "svg-icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2,.cls-3,.cls-4{fill:none;stroke:#4d69fa;}.cls-1,.cls-2{stroke-miterlimit:10;}.cls-2,.cls-3{stroke-width:0.75px;}.cls-3,.cls-4{stroke-linecap:round;stroke-linejoin:round;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "tablier-icone") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 16.99,
    cy: 2.54,
    r: 2.04
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2.54,4.58A2,2,0,0,1,2.54.5"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 16.6,
    y1: 0.5,
    x2: 2.54,
    y2: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 16.8,
    y1: 4.58,
    x2: 2.54,
    y2: 4.58
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 0.57,
    y1: 1.86,
    x2: 14.97,
    y2: 1.86
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 0.59,
    y1: 4.58,
    x2: 16.07,
    y2: 4.58
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 0.59,
    y1: 5.98,
    x2: 16.07,
    y2: 5.98
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 0.5,
    y1: 3.27,
    x2: 14.97,
    y2: 3.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 0.59,
    y1: 7.23,
    x2: 16.07,
    y2: 7.23
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 0.59,
    y1: 8.47,
    x2: 16.07,
    y2: 8.47
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 0.59,
    y1: 9.72,
    x2: 16.07,
    y2: 9.72
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 0.59,
    y1: 10.96,
    x2: 16.07,
    y2: 10.96
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 0.59,
    y1: 12.2,
    x2: 16.07,
    y2: 12.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 0.59,
    y1: 13.45,
    x2: 16.07,
    y2: 13.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 0.59,
    y1: 14.69,
    x2: 16.07,
    y2: 14.69
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 0.59,
    y1: 15.94,
    x2: 16.07,
    y2: 15.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 0.59,
    y1: 17.18,
    x2: 16.07,
    y2: 17.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 0.59,
    y1: 18.42,
    x2: 16.07,
    y2: 18.42
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 0.59,
    y1: 19.67,
    x2: 16.07,
    y2: 19.67
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTablierIcone);
export default __webpack_public_path__ + "static/media/tablier-icone.734429483e3abe5347cd318447844c89.svg";
export { ForwardRef as ReactComponent };